import React from 'react'

const SkeletonCard = ({ width, minWidth = 0, borderRadius }) => {
  return (
    <div
      className={`max-w-[${width}px] min-w-[${minWidth}px] w-[${width}px] h-[auto] rounded-[${borderRadius}px] overflow-hidden`}
    >
      <div className={`min-w-[${minWidth}px] w-full h-[${width}px] rounded-[10px] overflow-hidden`}>
        <div className="skeletonLoader" />
      </div>
      <div className="w-[100px] h-[14px] mt-[15px] rounded-[10px] overflow-hidden">
        <div className="skeletonLoader" />
      </div>
      <div className="w-[120px] h-[20px] mt-[8px] rounded-[10px] overflow-hidden">
        <div className="skeletonLoader" />
      </div>
      <div className="w-[50px] h-[18px] mt-[8px] rounded-[10px] overflow-hidden">
        <div className="skeletonLoader" />
      </div>
      <div className="w-[110px] h-[20px] mt-[12px] rounded-[10px] overflow-hidden">
        <div className="skeletonLoader" />
      </div>
    </div>
  )
}

export default SkeletonCard
